import { render, staticRenderFns } from "./amount.vue?vue&type=template&id=25520ab5&"
import script from "./amount.vue?vue&type=script&lang=js&"
export * from "./amount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports